import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import AppRouter from "router";
import notification from "antd/lib/notification";
// import registerServiceWorker from "./registerServiceWorker";
import store from "store";
import VersionChecker from "components/version-checker";

import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import "antd/dist/antd.css";
import "styles/ant-overrides.css";

window.addEventListener("offline", () => {
    notification.error({
        message: "No Internet Connectivity",
    });
});

window.addEventListener("online", () => {
    notification.open({
        message: "Internet Connectivity Resumed"
    });
});

// window.navigator.connection.addEventListener("change", () => {
//     if(window.navigator.connection.effectiveType !== "4g") {
//         notification.error({
//             message: "Slow Internet Connection"
//         });
//     }
// });

if (window.navigator.connection && typeof window.navigator.connection.addEventListener === "function") {
    window.navigator.connection.addEventListener("change", () => {
        if (window.navigator.connection.effectiveType !== "4g") {
            notification.error({
                message: "Slow Internet Connection"
            });
        }
    });
} else {
    console.warn("Network Information API is not supported in this browser.");
}

ReactDOM.render(
    <DragDropContextProvider backend={HTML5Backend}>
        <Provider store={store}>
            <React.Fragment>
                <AppRouter store={store} />
                <VersionChecker />
            </React.Fragment>
        </Provider>
    </DragDropContextProvider>,
    document.getElementById("root")
);
